import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiMensagensService } from '../../services/api-mensagens.service';

export const mensagemPendenteGuard: CanActivateFn = () => {

  const apiMensagens = inject(ApiMensagensService);
  const router = inject(Router);

  return apiMensagens.verificarMensagemNoAcessoAoSistema().pipe(
    map(mensagem => {

      if (mensagem === null || mensagem.idMensagemAceite === 0) { return true; }

      const mensagemIgnorada = localStorage.getItem(`unip_mensagem_${mensagem.idMensagemAceite}`) === 'true';
      if (mensagemIgnorada) { return true; }

      sessionStorage.setItem('reload', 'true');
      router.navigate(['/mensagem', mensagem.idMensagemAceite]);
      return false;
    }),
    catchError(() => of(true))
  );
};
